var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 18.5,
    fill: "#27D639"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7504 11.9355C14.1953 11.9355 11.4444 16.9832 13.8616 20.8036C14.3642 21.5979 15.0503 22.2562 15.8598 22.7241V28.2001H21.641V22.7241C23.3777 21.7202 24.5317 19.8457 24.5317 17.7168C24.5317 14.529 21.9382 11.9355 18.7504 11.9355ZM17.016 27.0439V25.8876H20.4848V27.0439H17.016ZM20.4848 22.0204V24.7314H19.3285V18.9897L20.8055 18.0051L20.1641 17.0431L18.7504 17.9855L17.3367 17.0431L16.6954 18.0051L18.1723 18.9897V24.7314H17.016V22.0204L16.6952 21.8609C15.1101 21.0731 14.1254 19.4852 14.1254 17.7168C14.1254 15.1666 16.2002 13.0918 18.7504 13.0918C21.3006 13.0918 23.3754 15.1666 23.3754 17.7168C23.3754 20.8939 20.5323 21.9787 20.4848 22.0204Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2656 17.1387H28V18.2949H26.2656V17.1387Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 17.1387H11.2344V18.2949H9.5V17.1387Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6538 11.9951L24.88 10.7689L25.6975 11.5864L24.4713 12.8126L23.6538 11.9951Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1719 8.4668H19.3281V10.2012H18.1719V8.4668Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8003 11.585L12.6178 10.7675L13.844 11.9937L13.0265 12.8112L11.8003 11.585Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenBulb);
export default __webpack_public_path__ + "static/media/greenBulb.1407efd2148c30b009d6e4dbd2a9eb1d.svg";
export { ForwardRef as ReactComponent };